/**
 * Initializes an Alpine.js data object to manage video playback on hover events.
 * Key features include:
 * 1. Event Handling: Sets up mouseenter and mouseleave events to play and pause video.
 * 2. Video Element Management: Dynamically binds to video elements within the component for interaction.
 * 3. Initialization: Configures the video controls upon initialization to respond to hover actions.
 */

function hoverVideo() {
  return{
    videoElement: null,
    init() {
      this.videoElement = this.$el.querySelector('video');
      
      this.videoElement.addEventListener('mouseenter', () => {
        this.videoElement.play();
      });
      this.videoElement.addEventListener('mouseleave', () => {
        this.videoElement.pause();
      });
    }
  }    
}

document.addEventListener('alpine:init', () => {
  Alpine.data('hoverVideo', hoverVideo);
});